import React, { ReactNode } from 'react'
import { ApiOutlined, HistoryOutlined, HomeOutlined, KeyOutlined, LineChartOutlined, ProfileOutlined, SafetyOutlined, SearchOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons';
import { ROLE } from './index'
const Callback = React.lazy(() => import('@/pages/Callback'))
// import CounterPage from '../pages/CounterPage';
const Forbidden = React.lazy(() => import('@/pages/Forbidden'))
const LoginPage = React.lazy(() => import('@/pages/Login'))
const AccountSetting = React.lazy(() => import('@/pages/Settings/Account'))
const ProxySetting = React.lazy(() => import('@/pages/Settings/Proxy'))
const ProxyUsage = React.lazy(() => import('@/pages/Reports/ProxyUsage'))
const ApiKeySetting = React.lazy(() => import('@/pages/Settings/ApiKey'))
const HomePage = React.lazy(() => import('@pages/HomePage'));
const SystemConfig = React.lazy(() => import('@/pages/Settings/SystemConfig'))
const SystemLogs = React.lazy(() => import('@/pages/Lookup/SystemLogs'))
const YahooResponses = React.lazy(() => import('@/pages/Lookup/YahooResponses'))

interface MenuItem {
    key: string
    label?: string
    path: string
    icon?: ReactNode
    roles?: string[]
    element?: ReactNode
    children?: MenuItem[]
    protected?: boolean
}

const items: MenuItem[] = [
    {
        key: '/',
        path: '/',
        label: 'Dashboard',
        icon: <HomeOutlined />,
        element: <HomePage />,
        protected: true
    },
    {
        key: '/login',
        path: '/login',
        element: <LoginPage />
    },
    {
        key: '/forbidden',
        path: '/forbidden',
        element: <Forbidden />,
        protected: true
    },
    // {
    //     key: '/counter',
    //     path: '/counter',
    //     label: 'Counter',
    //     element: <CounterPage />,
    //     protected: true
    // },
    {
        key: '/callback',
        path: '/callback',
        element: <Callback />,
    },
    {
        key: '/setting',
        path: '/setting',
        label: 'Cài đặt',
        icon: <SettingOutlined />,
        children: [{
            key: '/setting/account',
            path: '/setting/account',
            label: 'Cài đặt tài khoản mua hộ/đấu giá',
            icon: <UserOutlined />,
            element: <AccountSetting />,
            protected: true,
            roles: []
        }, {
            key: '/setting/proxy',
            path: '/setting/proxy',
            label: 'Cài đặt proxy',
            icon: <SafetyOutlined />,
            element: <ProxySetting />,
            protected: true,
            roles: [ROLE.ADMIN]
        }, {
            key: '/setting/api-key',
            path: '/setting/api-key',
            label: 'Cài đặt khoá xác thực API',
            icon: <KeyOutlined />,
            element: <ApiKeySetting />,
            protected: true,
            roles: [ROLE.ADMIN]
        }, {
            key: '/setting/system-config',
            path: '/setting/system-config',
            label: 'Cài đặt cấu hình hệ thống',
            icon: <SettingOutlined />,
            element: <SystemConfig />,
            protected: true,
            roles: [ROLE.ADMIN]
        }]
    },
    {
        key: '/report',
        path: '/report',
        label: 'Báo cáo',
        icon: <LineChartOutlined />,
        children: [{
            key: '/report/proxy-usage',
            path: '/report/proxy-usage',
            icon: <HistoryOutlined />,
            label: 'Lịch sử sử dụng proxy',
            element: <ProxyUsage />,
            protected: true,
            roles: []
        }]
    }, {
        key: '/look-up',
        path: '/look-up',
        label: 'Tra cứu',
        icon: <SearchOutlined />,
        children: [{
            key: '/look-up/system-logs',
            path: '/look-up/system-logs',
            label: 'Nhật ký hệ thống',
            icon: <ProfileOutlined />,
            element: <SystemLogs />,
            protected: true,
            roles: [ROLE.ADMIN]
        }, {
            key: '/look-up/yahoo-response',
            path: '/look-up/yahoo-response',
            label: 'Phản hồi đặt giá đấu Yahoo',
            icon: <ApiOutlined />,
            element: <YahooResponses />,
            protected: true,
            roles: []
        }]
    }
]

export { type MenuItem, items }
